export default "__VITE_ASSET__542bb41e__"